<script setup lang="ts">
  import { computed, inject, ref, type ComputedRef, type Ref } from 'vue';
  import { useRoute, type RouteLocationRaw } from 'vue-router';

  import { EnumRoutes } from '@/helpers/enums/routes.enum';

  const canRegister: Ref<boolean> = inject('canRegister', ref(false));

  const registerRoute: ComputedRef<RouteLocationRaw> | undefined = inject(
    'registerRoute',
    undefined
  );
  const loginRoute: ComputedRef<RouteLocationRaw> | undefined =
    inject('loginRoute');

  const registerText: Ref<string> = inject('registerText', ref('Register'));
  const loginText: Ref<string> = inject('loginText', ref('Login'));

  const route = useRoute();
  const path = computed(() => {
    return route.path == '/' ? window.location.pathname : route.path;
  });
</script>

<template>
  <v-btn
    v-if="path !== EnumRoutes.auth.login.path"
    :active="false"
    color="primary"
    :to="loginRoute"
    variant="text"
    aria-label="Log In"
  >
    {{ loginText }}
  </v-btn>
  <v-btn
    v-if="canRegister && path !== EnumRoutes.auth.register.path"
    :active="false"
    color="primary"
    :to="registerRoute"
    aria-label="Register"
    variant="flat"
  >
    {{ registerText }}
  </v-btn>
</template>
